import { Box, Typography } from "@mui/material";
import { useState } from "react";

import StyledLargeButton from "components/Styled/Button/StyledLargeButton";
import StyledLink from "components/Styled/Link";

import SubmitContentDialog from "./SubmitContentDialog";

export const BRAND_AMBASSADOR_TERMS_AND_CONDITIONS =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Bento%E2%80%99s%20Brand%20Ambassador%20Program%20Terms%20and%20Conditions.pdf";

const STEPS = [
  {
    number: 1,
    title: "Create & Share",
    subtitle: "Post a TikTok about Bento and share your Spark Code with us.",
  },
  {
    number: 2,
    title: "Get Real Data",
    subtitle:
      "We'll run ads with your content and share performance stats you can use to improve.",
  },
  {
    number: 3,
    title: "Earn Monthly",
    subtitle:
      "Get paid $50/month for every month we use your high-performing content.",
  },
];

const PERKS = [
  {
    icon: "fa-regular fa-chart-line",
    text: "Real ad performance data for your portfolio",
  },
  {
    icon: "fa-regular fa-file-lines",
    text: "Case study to pitch future brand deals",
  },
  {
    icon: "fa-regular fa-circle-dollar",
    text: "Potential for recurring monthly income",
  },
];

const PURPLE = "#b2b3f6";

const BrandAmbassadorProgram = () => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <Box sx={{ maxWidth: 600 }}>
      {/* Header */}
      <Typography variant="h4" gutterBottom>
        <Box
          component="i"
          className="fa-regular fa-arrow-trend-up"
          sx={{ color: PURPLE, mr: 1 }}
        />
        Brand Ambassador Program
      </Typography>

      <Typography color="text.secondary" sx={{ mb: 4 }}>
        Create content about Bento, get real ad performance data, and earn
        monthly if your content performs well.{" "}
        <StyledLink href={BRAND_AMBASSADOR_TERMS_AND_CONDITIONS}>
          T&C apply
        </StyledLink>
      </Typography>

      {/* Steps */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mb: 4 }}>
        {STEPS.map((step) => (
          <Box
            key={step.number}
            sx={{ display: "flex", alignItems: "flex-start", gap: 2.5 }}
          >
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                bgcolor: "purple.dark",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: 15,
                  lineHeight: 1,
                }}
              >
                {step.number}
              </Typography>
            </Box>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                {step.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {step.subtitle}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>

      {/* Perks callout */}
      <Box
        sx={{
          bgcolor: "#fff",
          border: `2px solid ${PURPLE}`,
          borderRadius: 3,
          p: 3,
          mb: 4,
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
          What you get:
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
          {PERKS.map((perk, i) => (
            <Box
              key={i}
              sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
            >
              <Box
                component="i"
                className={perk.icon}
                sx={{ color: PURPLE, fontSize: 18, width: 22, flexShrink: 0 }}
              />
              <Typography>{perk.text}</Typography>
            </Box>
          ))}
        </Box>
      </Box>

      {/* CTA */}
      <StyledLargeButton onClick={() => setDialogOpen(true)}>
        Submit your content
      </StyledLargeButton>

      <SubmitContentDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </Box>
  );
};

export default BrandAmbassadorProgram;
